
import * as angular from "angular";

export class AutoFocus implements angular.IDirective {

    restrict = "A";

    link: (scope: angular.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => void;

    constructor(private readonly $timeout: angular.ITimeoutService) {

        AutoFocus.prototype.link = ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attrs: ng.IAttributes) => {

            $scope.$watch($attrs["autoFocus"], (focus: boolean) => {
                // If we did not pass an argument then assume auto-focus=true
                if ($attrs["autoFocus"].length == 0) {
                    focus = true;
                }

                this.setFocus(focus, $element);
            });
        }
    }

    setFocus(focus: boolean, $element: JQuery) {
        if (!focus) {
            return;
        }

        this.$timeout(() => {
            var elementToFocus = $element;

            if (!elementToFocus.is("input")) {
                elementToFocus = $element.find("input").first();
            }

            if (!elementToFocus || !elementToFocus.get(0)) {
                return;
            }

            (elementToFocus.get(0) as any).focus();
        }, 100);
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($timeout: angular.ITimeoutService) => new AutoFocus($timeout);

        directive.$inject = ["$timeout"];

        return directive;
    }
}
